import { useQuery } from "@tanstack/react-query";
import { AIModelProvider } from "@graylog/enterprise-api";
const useModelsQuery = (provider, extraQueryKey, credentials, disabled = false) => {
  const { data, isFetching, error } = useQuery({
    // The caller uses a safe credential identifier in the key instead of exposing the credentials.
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ["ai-model-provider-models", provider, extraQueryKey],
    queryFn: () => AIModelProvider.listModels(provider, credentials),
    enabled: Boolean(provider) && !disabled,
    // Retry only genuine server faults; a 4xx means the credentials are refused and will not change until edited.
    retry: (failureCount, err) => {
      var _a;
      return failureCount < 2 && ((_a = err == null ? void 0 : err.status) != null ? _a : 0) >= 500;
    }
  });
  return { data: data != null ? data : [], isFetching, error: error != null ? error : null };
};
export default useModelsQuery;
